import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { IReasons, ITimes } from '../../interface/absences'
import { IAbsenceEntry } from '../../interface/absenceEntry'
import { CEditAbsenceTime } from '../../constants/editAbsenceTime'

export interface absenceReasons {
    reasons: Array<IReasons>;
    times: Array<ITimes>;
    editEntry: IAbsenceEntry;
    absenceChangeCompledetModal: boolean;
}

const initialState: absenceReasons = {
    reasons: [],
    times: [],
    editEntry: CEditAbsenceTime,
    absenceChangeCompledetModal: false
}

export const absenceReasonsSlice = createSlice({
    name: 'absenceReasons',
    initialState,
    reducers: {
        setReasons: (state, action: PayloadAction<Array<IReasons>>) => {
            state.reasons = action.payload
        },

        setTimes: (state, action: PayloadAction<Array<ITimes>>) => {
            state.times = action.payload
        },

        setEditEntry: (state, action: PayloadAction<IAbsenceEntry>) => {
            state.editEntry = action.payload
        },

        setAbsenceChangeCompledetModal: (state, action: PayloadAction<boolean>) => {
            state.absenceChangeCompledetModal = action.payload
        },

    },
})

// Action creators are generated for each case reducer function
export const { setReasons, setTimes, setEditEntry, setAbsenceChangeCompledetModal } = absenceReasonsSlice.actions

export default absenceReasonsSlice.reducer